export const sortByTeeTime = (players, r1TeeTime, r2TeeTime) => {
    let teeTime = '';
    if (r1TeeTime) teeTime = 'r1TeeTime';
    //if (r2TeeTime) teeTime = 'r2TeeTime';
    const teeTimeGroups = {};
    const result = [];
    const sortedByTeeTime = [...players].sort((a, b) => {
        if (!a || !a[teeTime]) {
            return 1;
        }
        if (!b || !b[teeTime]) {
            return -1;
        }
        return new Date(a[teeTime]) - new Date(b[teeTime]);
    });

    sortedByTeeTime.forEach((player) => {
        const curTeeTime = player[teeTime];

        if (!teeTimeGroups[curTeeTime]) {
            teeTimeGroups[curTeeTime] = [];
        }

        teeTimeGroups[curTeeTime].push(player);
    });

    Object.keys(teeTimeGroups).forEach((key) => {
        teeTimeGroups[key].sort((a, b) => a.r1StartHole - b.r1StartHole);
        result.push(...teeTimeGroups[key]);
    });

    return result;
};

export const filteringStrategies = {
    selectCourse: {
        filteringFunc: ({ players, selectValue }) => {
            return players.filter((courseItem) => courseItem.locationName === selectValue);
        }
    },
    searchPlayers: {
        filteringFunc: ({ players, searchQuery }) => {
            const filterBy = ['firstName', 'lastName'];

            return players.filter((item) => {
                return filterBy.some((prop) => {
                    return searchQuery.some((val) => {
                        return item[prop].toLowerCase().includes(val);
                    });
                });
            });
        }
    }
};
